module.exports = __webpack_public_path__ + "static/media/2018 - 19 Elsie Gung_-min.5b1d9a71.jpg";